export class TimeZoneSingleton {
  public adminTimeZone: string;

  public laboratoryTimeZone: string | null;

  private static instance: TimeZoneSingleton;

  private constructor(timeZone: string | null, adminTimeZone: string) {
    this.adminTimeZone = adminTimeZone;
    this.laboratoryTimeZone = timeZone;
  }

  public static getInstance(): TimeZoneSingleton {
    return this.instance;
  }

  public static setInstance(laboratoryTimeZone: string | null): void {
    this.instance = new TimeZoneSingleton(laboratoryTimeZone, 'Europe/Paris');
  }
}
